class ImageMagnifier {
  constructor(image, options = {}) {
    this.image = image;
    this.options = {
      zoom: 2.5,
      glassSize: 200,
      smoothing: 0.3,
      ...options
    };
    this.initialize();
  }

  initialize() {
    // Create wrapper elements
    this.container = document.createElement('div');
    this.container.className = 'magnifier-container';
    this.glass = document.createElement('div');
    this.glass.className = 'magnifier-glass';
    this.overlay = document.createElement('div');
    this.overlay.className = 'zoom-overlay';

    // Set up container
    this.image.parentElement.insertBefore(this.container, this.image);
    this.container.appendChild(this.image);
    this.container.appendChild(this.glass);
    this.container.appendChild(this.overlay);

    // Glass size
    this.glass.style.width = `${this.options.glassSize}px`;
    this.glass.style.height = `${this.options.glassSize}px`;

    // Current position
    this.currentX = 0;
    this.currentY = 0;
    this.targetX = 0;
    this.targetY = 0;

    // Event listeners
    this.image.addEventListener('mousemove', this.handleMouseMove.bind(this));
    this.image.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.image.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    
    // Animation
    this.animate = this.animate.bind(this);
    this.animationFrame = null;
  }

  handleMouseMove(e) {
    const bounds = this.image.getBoundingClientRect();
    this.targetX = e.clientX - bounds.left;
    this.targetY = e.clientY - bounds.top;
    
    if (!this.animationFrame) {
      this.animationFrame = requestAnimationFrame(this.animate);
    }
  }

  animate() {
    // Smooth movement
    this.currentX += (this.targetX - this.currentX) * this.options.smoothing;
    this.currentY += (this.targetY - this.currentY) * this.options.smoothing;

    // Calculate positions
    const glassX = this.currentX - this.options.glassSize / 2;
    const glassY = this.currentY - this.options.glassSize / 2;

    // Update glass
    this.glass.style.left = `${glassX}px`;
    this.glass.style.top = `${glassY}px`;

    // Update background
    const bgX = this.currentX * this.options.zoom - this.options.glassSize / 2;
    const bgY = this.currentY * this.options.zoom - this.options.glassSize / 2;

    this.glass.style.backgroundImage = `url(${this.image.src})`;
    this.glass.style.backgroundSize = `${this.image.width * this.options.zoom}px ${this.image.height * this.options.zoom}px`;
    this.glass.style.backgroundPosition = `-${bgX}px -${bgY}px`;

    if (Math.abs(this.targetX - this.currentX) > 0.1 || Math.abs(this.targetY - this.currentY) > 0.1) {
      this.animationFrame = requestAnimationFrame(this.animate);
    } else {
      this.animationFrame = null;
    }
  }

  handleMouseEnter() {
    this.glass.style.display = 'block';
    this.image.classList.add('zoom-active');
  }

  handleMouseLeave() {
    this.glass.style.display = 'none';
    this.image.classList.remove('zoom-active');
    this.animationFrame = null;
  }
}

// Initialize with custom options
document.addEventListener('DOMContentLoaded', () => {
  const productImages = document.querySelectorAll('.product-header3_main-image');
  productImages.forEach(img => new ImageMagnifier(img, {
    zoom: 2.5,
    glassSize: 200,
    smoothing: 0.3
  }));
});